import { log } from '../../common/common';
import { discussReferConstants } from '../constants/discussRefer.constant';
import { logoutUser } from './login.action';
import axiosInstance from '../helper/axiosInstance';

const getLandingSuccess = (payload) => {
  return {
    type: discussReferConstants.FETCH_LANDING_SUCCESS,
    payload
  };
};
const getLandingFailure = (payload) => {
  return {
    type: discussReferConstants.FETCH_LANDING_FAILURE,
    payload
  };
};
const getHospitalSuccess = (payload) => {
  return {
    type: discussReferConstants.GET_HOSPITAL_PROFILE_SUCCESS,
    payload
  };
};
const getHospitalFailure = (payload) => {
  return {
    type: discussReferConstants.GET_HOSPITAL_PROFILE_FAILURE,
    payload
  };
};
const getRecommendedSuccess = (payload) => {
  return {
    type: discussReferConstants.GET_RECOMMENDED_SUCCESS,
    payload
  };
};
const getRecommendedFailure = (payload) => {
  return {
    type: discussReferConstants.GET_RECOMMENDED_FAILURE,
    payload
  };
};
const getActivitiesSuccess = (payload) => {
  return {
    type: discussReferConstants.GET_ACTIVITIES_SUCCESS,
    payload
  };
};
const getActivitiesFailure = (payload) => {
  return {
    type: discussReferConstants.GET_ACTIVITIES_FAILURE,
    payload
  };
};
export const getLandingPageData = (callback) => {
  return async (dispatch) => {
    axiosInstance
      .get('referral/fetch_landing_page')
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch(getLandingSuccess(response.data));
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
        dispatch(getLandingFailure(error));
      });
  };
};
export const getHospitalProfilePageData = (id, all_referral, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(
        `referral/fetch_user_activity?all_referral=${all_referral}&referred_client_master_id=${id}`
      )
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch(getHospitalSuccess(response.data));
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
        dispatch(getHospitalFailure(error));
      });
  };
};
export const getActivityDetail = (id, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`referral/fetch_user_activity?all_referral=true&master_referral_discussion_id=${id}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch(getHospitalSuccess(response.data));
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
        dispatch(getHospitalFailure(error));
      });
  };
};
export const getAllActivities = (callback) => {
  return async (dispatch) => {
    axiosInstance
      .get('referral/fetch_user_activity?all_referral=true')
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch(getActivitiesSuccess(response.data));
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
        dispatch(getActivitiesFailure(error));
      });
  };
};
export const getRecommendedDataList = (id, pagination, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(
        `referral/fetch_recommended_data?referred_client_master_id=${id}&from=${pagination}&to=5`
      )
      .then((response) => {
        if (response.data) {
          callback(response.data);
          dispatch(getRecommendedSuccess(response.data));
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
        dispatch(getRecommendedFailure(error));
      });
  };
};
export const postReferral = (jsonObj, callback) => {
  return async (dispatch) => {
    axiosInstance
      .post('referral/add_referral_discussion', jsonObj)
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
      });
  };
};
export const postReInitialRefer = (jsonObj, callback) => {
  return async (dispatch) => {
    axiosInstance
      .post('referral/reInitiate_referral_discussion', jsonObj)
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
      });
  };
};
export const fetchConversationData = (discussion_code, callback) => {
  return async (dispatch) => {
    axiosInstance
      .get(`referral/fetch_reffered_discuss_chat_data?referral_discussion_code=${discussion_code}`)
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
      });
  };
};
export const postDiscussChat = (jsonObj, callback) => {
  return async (dispatch) => {
    axiosInstance
      .post('referral/put_reffered_discuss_chat_data', jsonObj)
      .then((response) => {
        if (response.data) {
          callback(response.data);
        }
      })
      .catch((error) => {
        if (error == 'loginAgain' || error?.name == 'InvalidTokenError') {
          dispatch(logoutUser());
        }
        log('error', error);
        callback('error');
      });
  };
};
// referral / add_referral_discussion;
//referral/reInitiate_referral_discussion
//https://developer.clirnet.com/knowledge/rnv19/referral/fetch_reffered_discuss_chat_data?referral_discussion_code=CNMRP000090
//https://developer.clirnet.com/knowledge/rnv19/referral/put_reffered_discuss_chat_data
// {
//     "referral_discussion_code":"CNMRP000090",
//     "sender_id":"1",
//     "sender_display_name":"Anant Sahu",
//     "recipient_id":"289",
//     "message":"Heelo medica there"
// }
